export default __webpack_public_path__ + "static/media/landing-tick.4d1c6d34.png";